import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem;

  &:not(&:last-of-type) {
    border-bottom: 1px solid #3d3d3d;
  }
`;

export const SectionHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;

  h2 {
    font-size: 1.1rem;
    font-weight: bold;
  }
`;

export const AddressesWrapper = styled.div`
  display: grid;
  row-gap: 1.5rem;
  grid-template-rows: 1fr auto-fill;
`;

export const AddressRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  svg {
    margin-right: 2rem;

    path {
      stroke: var(--white);
    }

    cursor: pointer;
  }
`;

export const ClientInfoWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  row-gap: 2rem;
  grid-template-rows: 1fr 1fr;

  @media (max-width: 1400px) {
    grid-template-columns: 1fr !important;
    grid-template-rows: auto;
  }
`;

export const BeneficiaryInfoWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 2rem;
  grid-template-rows: 1fr auto;
`;

export const ArrivalTimeWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 2rem;
  grid-template-rows: 1fr 1fr;
`;

export const AttachmentsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 0.5rem;
  row-gap: 1rem;
  grid-template-rows: auto;
  place-items: start;

  img {
    cursor: pointer;
    width: 5rem;
    height: 5rem;
  }
`;

export const Topic = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const Subtitle = styled.p`
  font-size: 0.875rem;
  color: #b8b8b8;
`;

export const Badge = styled.div`
  width: 100%;
  padding: 0.5625rem 0.75rem;

  margin-top: 0.5rem;
  border-radius: 6.25rem;

  font-size: 0.85rem;
  font-family: DM Sans;
  min-height: 2rem;

  color: var(--green);
  background: rgba(71, 212, 68, 0.1);
`;

export const TrackButton = styled.button`
  width: 100%;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  background: var(--primary);
  transition: all 0.3s ease-in-out;
  font-weight: bold;

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
    opacity: 0.4;
  }
`;
